module.exports = __webpack_public_path__ + "static/media/no-data.f0058e62.svg";